import i18n from 'i18next';
import LanguageDetector from 'i18next-browser-languagedetector';
import { initReactI18next } from 'react-i18next';

import { FALLBACK_LANGUAGE, LANGUAGES } from './languages';
import { resources } from './namespaces';
import urlLanguageDetector from './urlLanguageDetector';

const languageDetector = new LanguageDetector();
languageDetector.addDetector(urlLanguageDetector);

// The URL's language first; for a URL without one — before LanguageGate puts it there — the remembered language,
// then the browser's. Every language the URL takes is remembered, so a bare `/` opens the last one seen.
// Resources are bundled, so init completes synchronously and useTranslation never suspends
// oxlint-disable-next-line import/no-named-as-default-member -- the default instance is what react-i18next binds to
void i18n
    .use(languageDetector)
    .use(initReactI18next)
    .init({
        resources,
        supportedLngs: LANGUAGES,
        fallbackLng: FALLBACK_LANGUAGE,
        ns: ['common'],
        defaultNS: 'common',
        interpolation: {
            escapeValue: false,
        },
        detection: {
            order: ['urlPath', 'localStorage', 'navigator'],
            caches: ['localStorage'],
            lookupLocalStorage: 'i18nextLng',
        },
    });

export default i18n;
